import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoCanalMidiaSocialMultiSelectComponent } from './novo-canal-midia-social-multi-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoCanalMidiaSocialMultiSelectComponent],
  exports: [NovoCanalMidiaSocialMultiSelectComponent]
})
export class NovoCanalMidiaSocialMultiSelectModule {}
